import React from 'react'
import { numberOnly } from '../../../server/util';

class CounterComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            count: this.props.item.quantity || 1
        }
        this.increment = this.increment.bind(this)
        this.handleCountChange = this.handleCountChange.bind(this)
        this.decrement = this.decrement.bind(this)
    }
    static getDerivedStateFromProps(props, current_state) {
        if (current_state.count !== props.item.quantity) {
            return {
                count: props.item.quantity,
            }
        }
        return null
    }
    handleCountChange(value) {
        const x = this.props.updateQuantity(this.props.item, parseInt(value) || 0, 'change')
        if (x)
            this.setState({ count: value })
    }
    increment() {
        if (this.props.readOnly) {
            return false
        } else {
            const a = this.state.count + 1
            console.log(a)
            const x = this.props.updateQuantity(this.props.item, a, 'increment')
            if (x)
                this.setState({ count: a })

        }

    }

    decrement() {
        if (this.props.readOnly) {

            return false
        } else {
            if (this.state.count != 1) {
                const a = this.state.count - 1

                const x = this.props.updateQuantity(this.props.item, a, 'decrement')
                if (x)
                    this.setState({ count: a })
            }
        }
    }
    render() {
        return (<div>
            {/* {!this.props.readOnly && <span onClick={this.increment}>+

            </span>}
            
            <p style={{marginBottom:0}}>{this.state.count}</p>
            {!this.props.readOnly &&<span
            onClick={this.decrement}>-</span>} */}
            <input style={{ padding: "0px 5px", minWidth: "30px", height: 26 }} type="text" min='0' className={'form-control'} value={this.state.count}
                onChange={(event) => this.handleCountChange(event.target.value)}
                onKeyDownCapture={numberOnly}
                disabled={this.props.readOnly}
            />
        </div>)
    }


}
export default CounterComponent


// WEBPACK FOOTER //
// ./src/components/Parent/ManageOrders/CounterComponent.jsx